import React, { useState, useEffect } from 'react';
import { collection, query, onSnapshot, orderBy, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  CalendarCheck, 
  Users, 
  LogOut, 
  Search, 
  Bell, 
  Menu, 
  X,
  PlusCircle,
  Settings // Yeni: Ayarlar ikonu eklendi
} from 'lucide-react';
import { auth, db } from '../../firebase/firebase-config';

// Bileşenleri İçeri Aktar
import './AdminPanel.css';
import CalendarView from '../CalendarView/CalendarView';
import DashboardView from '../DashboardView/DashBoardView';
import AddAppointmentView from '../AddAppointmentView/AddAppointmentView';
import SettingsView from '../SettingsView/SettingsView';

const AdminPanel = () => {
  const [appointments, setAppointments] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Firestore'dan verileri anlık çek
  useEffect(() => {
    const q = query(collection(db, "appointments"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const apts = [];
      querySnapshot.forEach((doc) => apts.push({ id: doc.id, ...doc.data() }));
      setAppointments(apts);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Arama filtresi
  const filteredAppointments = appointments.filter((apt) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      apt.fullName?.toLowerCase().includes(searchLower) || 
      apt.phone?.includes(searchTerm)
    );
  });

  // İşlem Fonksiyonları
  const handleApprove = async (id) => await updateDoc(doc(db, "appointments", id), { status: "Onaylandı" });
  
  const handleDelete = async (id) => {
    if (window.confirm("Bu randevuyu silmek istediğinize emin misiniz?")) {
      await deleteDoc(doc(db, "appointments", id));
    }
  };

  const handleLogout = () => signOut(auth).then(() => navigate('/login'));

  return (
    <div className="admin-layout">
      {/* Mobil Overlay */}
      <div 
        className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} 
        onClick={() => setIsSidebarOpen(false)}
      ></div>
      
      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <div className="brand-wrapper">
            <span className="brand-subtitle">ÇOCUK CERRAHİSİ UZMANI</span>
            <h2 className="brand-title">
              Op. Dr. <span>Mahmut</span> Aluç
            </h2>
          </div>
          <button onClick={() => setIsSidebarOpen(false)} className="mobile-close-btn">
            <X />
          </button>
        </div>
        
        <nav className="sidebar-menu">
          <div 
            className={`menu-item ${activeTab === 'dashboard' ? 'active' : ''}`} 
            onClick={() => { setActiveTab('dashboard'); setIsSidebarOpen(false); }}
          >
            <LayoutDashboard size={20} /> Dashboard
          </div>

          <div 
            className={`menu-item ${activeTab === 'add-appointment' ? 'active' : ''}`} 
            onClick={() => { setActiveTab('add-appointment'); setIsSidebarOpen(false); }}
            style={{ color: activeTab === 'add-appointment' ? '#4ade80' : 'inherit' }}
          >
            <PlusCircle size={20} /> Manuel Randevu
          </div>

          <div 
            className={`menu-item ${activeTab === 'appointments' ? 'active' : ''}`} 
            onClick={() => { setActiveTab('appointments'); setIsSidebarOpen(false); }}
          >
            <CalendarCheck size={20} /> Randevu Takvimi
          </div>

          <div 
            className={`menu-item ${activeTab === 'patients' ? 'active' : ''}`} 
            onClick={() => { setActiveTab('patients'); setIsSidebarOpen(false); }}
          >
            <Users size={20} /> Hastalar
          </div>

          {/* YENİ: AYARLAR SEKMESİ */}
          <div 
            className={`menu-item ${activeTab === 'settings' ? 'active' : ''}`} 
            onClick={() => { setActiveTab('settings'); setIsSidebarOpen(false); }}
          >
            <Settings size={20} /> Randevu Ayarları
          </div>

          <div className="menu-logout" onClick={handleLogout}>
            <LogOut size={20} /> Çıkış Yap
          </div>
        </nav>
      </aside>

      <main className="main-content">
        {/* Navbar */}
        <header className="admin-navbar">
          <div className="nav-left">
            <button className="hamburger-menu-btn" onClick={() => setIsSidebarOpen(true)}><Menu /></button>
            <div className="search-bar">
              <Search size={18} />
              <input 
                type="text" 
                placeholder="Hasta veya telefon ara..." 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
              />
            </div>
          </div>
          <div className="admin-profile">
            <Bell size={20} />
            <div className="profile-info">
              <strong>Mahmut Aluç</strong>
              <span className="desktop-only">SCÜ Çocuk Cerrahisi</span>
            </div>
          </div>
        </header>

        {/* Dinamik İçerik Alanı */}
        <div className="dashboard-content">
          {activeTab === 'dashboard' && (
            <DashboardView 
              appointments={appointments} 
              filteredAppointments={filteredAppointments} 
              loading={loading} 
              handleApprove={handleApprove} 
              handleDelete={handleDelete} 
            />
          )}
          
          {activeTab === 'add-appointment' && (
            <AddAppointmentView onComplete={() => setActiveTab('dashboard')} />
          )}

          {activeTab === 'appointments' && (
            <CalendarView appointments={appointments} />
          )}

          {activeTab === 'settings' && (
            <SettingsView />
          )}

          {activeTab === 'patients' && (
            <div className="patients-placeholder">
              <h3>Hasta Kayıtları</h3>
              <p>Bu bölüm geliştirilme aşamasındadır.</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default AdminPanel;